module.exports = __webpack_public_path__ + "static/img/android.ab09ee99.png";